
      if (import.meta.env?.VITE_ENABLE_GPTENGINEER === 'true') {
        const s = document.createElement('script');
        s.type = 'module';
        s.src = 'https://cdn.gpteng.co/gptengineer.js';
        document.head.appendChild(s);
      }
    